import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// Replace these with your actual Firebase project credentials
const firebaseConfig = {
  apiKey: "AIzaSyCUS5oXEcoFUQtu_GYHLNCqXBkYrC5L5aU",
  authDomain: "yalimolagastudios.firebaseapp.com",
  projectId: "yalimolagastudios",
  storageBucket: "yalimolagastudios.firebasestorage.app",
  messagingSenderId: "336943161697",
  appId: "1:336943161697:web:197cdc855d47757bf6a520",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

